import AnswersContainer from './AnswersContainer';
export default AnswersContainer;